// material-ui
import {} from '@mui/material'
import { ResolvePath } from 'features/firebase-app'
import { useNavigate } from 'react-router-dom'

import TitleService from 'title-service'

import { Views } from 'features/enumerations'

// assets
import * as autoThunks from 'features/auto-thunks'
import { useEffect } from 'react'

import AddProfileButton from 'components/AddProfileButton'
import ProfileEditItem from 'components/ProfileEditItem'
import ProfileEditSection from 'components/ProfileEditSection'
import ProfileHeader from 'components/ProfileHeader'
import ProfileList from 'components/ProfileList'
import ProfileScene from 'components/ProfileScene'
import ProfileSectionContainer from 'components/ProfileSectionContainer'
import { getUserClaims } from 'features/application/application-slice'
import { get_all_profile } from 'features/profile/profile-slice'
import { useDispatch, useSelector } from 'react-redux'

// ================================|| UI LIST - SIMPLE LIST ||================================ //

export default function SimpleList() {
  // Generate Grid
  let dispatch = useDispatch()
  const navigate = useNavigate()
  let claims = useSelector(getUserClaims)
  let profile_list = useSelector(get_all_profile)

  useEffect(() => {
    if (claims?.fire_user) {
      dispatch(autoThunks.get_profiles_for_edit({ userId: claims?.fire_user }))
    }
  }, [claims?.fire_user])

  function main(comp: any): any {
    return (() => {
      return (
        <div className="profile component">
          <ProfileScene>
            <ProfileHeader
              btnTitle={TitleService('Done')}
              onBtnClick={() => {
                history.back()
              }}
            ></ProfileHeader>
            <ProfileSectionContainer>
              <ProfileEditSection>
                <ProfileList>
                  {profile_list?.map((profileItem) => {
                    return (
                      <ProfileEditItem
                        key={profileItem?.id}
                        onClick={() => {
                          navigate(`/${Views.EditProfile}/${profileItem?.id}`)
                        }}
                        profileImage={profileItem.profileImage}
                        profileName={profileItem.name}
                      ></ProfileEditItem>
                    )
                  })}
                  <AddProfileButton
                    onClick={() => {
                      navigate(ResolvePath(`/${Views.AddProfile}`))
                    }}
                  />
                </ProfileList>
              </ProfileEditSection>
            </ProfileSectionContainer>
          </ProfileScene>
        </div>
      )
    })()
  }

  let output_main = main(null)

  return output_main
}
